<template>
    <g>
        <transition name="fade">
            <itemSet ref="itemSet" />
        </transition>
        <instructions v-if="this.$store.state.taskContainer.showInstructions" />
        <training v-if="this.$store.state.taskContainer.taskPlaying" />
    </g>
</template>

<script>
import { store } from "@/store.js";
import lang from "@/v/ipark/updating_colours/lang.js";
import instructions from "@/v/ipark/updating_colours/instructions.vue";
import training from "@/v/ipark/updating_colours/training.vue";
import itemSet from "@/v/ipark/updating_colours/itemSet.vue";

export default {
    name: "ipark_updating_colours",
    //genväg-alias:
    local: store.state.ipark_updating_colours,
    components: {
        instructions,
        training,
        itemSet,
    },
    mixins: [lang],
    computed: {
        text() {
            return this.getLocalisedText();
        }
    },
    mounted() {
        /*
        var level = this.$store.state.progress.updating_colours_level || 0;
        const params = this.calculateParameters(level);
        store.commit("ipark_updating_colours_initLevel", level);
        store.commit("ipark_updating_colours_resetitemSet");
        store.commit("ipark_updating_colours_showitemSet");
        */
        store.commit("taskPhase", 0);
        store.commit("setTaskMode", "ready");
    }
};
</script>

<style lang="stylus"></style>
